import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { directUpload, fileSelect, init } from "../../redux/actions/updateSticker";
import Footer from "../common/Footer";
import Header from "../common/Header";

export default function UpdateSticker() {
  const Input = styled("input")({
    display: "none"
  });

  const [file, setFile] = useState();

  const dispatch = useDispatch();
  const listId = useSelector(state => state.updateSticker.listId);
  const beforeStickerFile = useSelector(state => state.updateSticker.beforeStickerFile);
  const selectedImageURL = useSelector(state => state.updateSticker.selectedImageURL);

  useEffect(
    () => {
      const currentUrl = window.location.href;
      const parsedUrl = queryString.parseUrl(currentUrl);
      const { listId, itemId, stickerId, stickerFileName } = parsedUrl.query;

      const params = {
        listId: listId,
        itemId: itemId,
        stickerId: stickerId,
        stickerFileName: stickerFileName
      };
      dispatch(init(params));
    },
    [dispatch]
  );

  const handleOnChange = e => {
    setFile(e.target.files[0]);
    dispatch(fileSelect(e.target.files));
  };

  const handleImageResize = () => {
    dispatch(directUpload(file));
  };

  return (
    <Box>
      <Header />
      <Container maxWidth="md">
        <Grid container sx={{ flexGrow: 1 }} spacing={0} direction="row" alignItems="center" justifyContent="center">
          <Grid item xs={6}>
            <Box
              sx={{
                m: 8,
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Typography component="h4" variant="h7">
                変更前
              </Typography>
              <FormControl fullWidth sx={{ mt: 4, justifyContent: "center", alignItems: "center" }}>
                <Paper
                  sx={{
                    display: "flex",
                    height: 300,
                    width: 212,
                    alignItems: "center",
                    backgroundColor: theme => (theme.palette.mode === "dark" ? "#1A2027" : "#fff")
                  }}
                >
                  {
                    <img
                      src={`./neqst/images/${listId}/${beforeStickerFile}`}
                      // ★ローカル確認用
                      //src={`images/${listId}/${beforeStickerFile}`}
                      width={'100%'}
                      height={'100%'}
                      alt="BeforeImage"
                    />
                  }
                </Paper>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              sx={{
                m: 6,
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Typography component="h4" variant="h7">
                変更後
              </Typography>
              <FormControl fullWidth sx={{ mt: 4, justifyContent: "center", alignItems: "center" }}>
                <label>
                  <Paper
                    sx={{
                      display: "flex",
                      height: 300,
                      width: 212,
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: theme => (theme.palette.mode === "dark" ? "#1A2027" : "#fff")
                    }}
                    onChange={handleOnChange}
                  >
                    {selectedImageURL
                      ? // 選択した画像を表示
                        <img src={selectedImageURL} width={'100%'} height={'100%'} alt="Selected Image" />
                      : // ファイル選択用のInputコンポーネントを非表示にする
                        <div>
                          <Input
                            accept="image/*"
                            type="file"
                            onChange={handleOnChange}
                            id="imageInput"
                            sx={{ display: "none" }}
                          />
                          <Button
                            component="span"
                            variant="text"
                            disableElevation
                            size="medium"
                            sx={{
                              color: "#000000",
                              bgcolor: "#ffffff",
                              marginLeft: "auto",
                              padding: "2px 10px"
                            }}
                          >
                            画像を選択してください
                          </Button>
                        </div>}

                    <input
                      type="file"
                      onChange={handleOnChange}
                      id="imageInput"
                      style={{
                        display: "none",
                        cursor: "pointer",
                        position: "absolute", // 要素の位置を絶対的に指定
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0 // ボタンを透明にする
                      }}
                    />
                  </Paper>
                </label>
              </FormControl>
            </Box>
          </Grid>
        </Grid>
        <Button type="submit" onClick={handleImageResize} variant="contained" size="medium" sx={{ bgcolor: "#82b1ff" }} >
          変更
        </Button>
        <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, display: "flex" }}>
          <Button variant="contained" size="medium" href={`UpdateValuationItemMaster?selectAge=${listId}`} sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }} >
            戻る
          </Button>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}
